module.exports = __webpack_public_path__ + "static/media/credit_platinum_shopping.73fe786f.svg";